export const loginEnLocale = {
  'login.login': 'Log In',
  'login.before': 'Before you continue, you need to log in',
  'login.entry.user': 'Enter your email',
  'login.entry.password': 'Enter your password',
  'login.buttom.login': 'Log in',
  'login.loginWith': 'Or login with',
  'login.forgotPassword': 'Forgot your password?',
  'login.account': "Don't have an account?",
  'login.register': 'Register',
  'login.google': 'Log in with Google',
  'login.apple': 'Log in with Apple',
  'login.errors.user.required': 'Enter your email',
  'login.errors.password.required': 'Enter your password',

  'login.loading': 'Logging in...',
  'login.error': 'Incorrect user or password.',
  'login.success': 'Welcome!',
} as const;

export const loginEsLocale = {
  'login.login': 'Iniciar Sesión',
  'login.before': 'Antes de continuar, necesitas iniciar sesión',
  'login.entry.user': 'Ingresa tu correo',
  'login.entry.password': 'Ingresa tu contraseña',
  'login.buttom.login': 'Iniciar Sesión',
  'login.loginWith': 'O inicia sesión con',
  'login.forgotPassword': '¿Olvidaste tu contraseña?',
  'login.account': '¿No tienes cuenta?',
  'login.register': 'Regístrate',
  'login.google': 'Ingresar con Google',
  'login.apple': 'Ingresar con Apple',
  'login.errors.user.required': 'Ingrese su correo',
  'login.errors.password.required': 'Ingrese su contraseña',

  'login.loading': 'Iniciando sesión...',
  'login.error': 'Usuario o contraseña incorrectos.',
  'login.success': '¡Bienvenido!',
} as const;
